module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAQAAACR313BAAAAAXNSR0IArs4c6QAAAPFJREFUGNN1zTEvQ2EUxvHzAcxiemOpxCAGEsSChc0X6GaTJj6BwdCEDQsRo4jBZLRYahGbWO75H9cbS1tJCdIOJMfgTWnu9WwnvyfnEenHKtzaB3c2IcXoNm4XLHKGsz9ANs0T77qaist0aDGfkDquJ4O/7BhnV0TYwVkqGZvDORJcq1IaVnDhMxv/h4dpCd1sppytQlPo6uzP+TDJFTc0dCHx2B/OR+jpJQd6jjNVYF3nLW1mHBaYGo+JG+z98lc+KiKi1T5fUxcRuR+iLTibFizoFj0LFiyQc2rBAjVcdI1nIpEmr0QikQ5tIpEX2/gGorGtyrGTI08AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy_icon.png
// module id = geYV
// module chunks = 2